import axios from "axios";

// AUTH-3 deploy hardening (2026-02-13):
// On Emergent the frontend and backend always sit behind the SAME nginx ingress
// (preview: gardaj-crm.preview.emergentagent.com, production: crm.gardaj.com),
// with /api/* routed to the backend pod. If REACT_APP_BACKEND_URL points to
// the internal cluster ingress (e.g. *.cluster-X.deploy.emergentcf.cloud) while
// the browser is loaded from the custom domain, every API call becomes a
// cross-site request → Set-Cookie lands on the cluster domain → modern browsers
// (Safari ITP, Chrome 3p-cookie phaseout, Brave) silently drop the cookie →
// /api/auth/me returns 401 immediately after a 200 login.
//
// Fix: use REACT_APP_BACKEND_URL only when it explicitly matches the page's
// current origin. Otherwise default to a same-origin relative `/api` base.
// This guarantees first-party cookies in every browser, in every environment.
function resolveApiBase() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
  if (typeof window !== "undefined" && envUrl) {
    try {
      const u = new URL(envUrl);
      if (u.origin === window.location.origin) {
        return `${envUrl.replace(/\/$/, "")}/api`;
      }
    } catch (err) {
      // Malformed REACT_APP_BACKEND_URL → fall through to relative.
      // Surface this once in dev tools so a typo isn't fully silent.
      // eslint-disable-next-line no-console
      console.warn("Invalid REACT_APP_BACKEND_URL, using same-origin /api:", err?.message);
    }
  }
  // Same-origin relative base — Emergent ingress proxies /api/* to backend.
  return "/api";
}

const API_BASE = resolveApiBase();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err?.response?.status === 401) {
      // Bubble up — AuthContext will redirect
    }
    return Promise.reject(err);
  }
);

export { API_BASE };
export default api;
